import React from "react";

import { ProfileTypeAggregations } from "@platformsh/observability-graph/ContinuousProfiling";
import { useIntl } from "react-intl";

import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { ParseTimeDurationType } from "src/organization/pages/project/environment/metrics/utils/parseDimensions/types";

import useConprofContext from "../hooks/useConprofContext";

import ComparisonModeSwitch, {
  ComparisonModeSwitchProps
} from "./ComparisonModeSwitch";
import * as S from "./Controls.styles";
import ProfileTypeSelect, { ProfileTypeSelectProps } from "./ProfileTypeSelect";

type Props = {
  typeframeProps: {
    isUpdating?: boolean;
    pollInterval?: any;
    lastUpdated?: Date;
    timeframe: {
      onChange: (timeframe: TimeFrameType) => void;
      timeframe: TimeFrameType;
      timeDuration?: ParseTimeDurationType;
    };
  };
  profileTypesProps: ProfileTypeSelectProps;
  comparisonModeProps: ComparisonModeSwitchProps;
};

const Controls = ({
  comparisonModeProps,
  typeframeProps,
  profileTypesProps
}: Props) => {
  const intl = useIntl();
  const { data } = useConprofContext();
  const profileType = data?.profileType;

  return (
    <S.Layout>
      <S.Section className="display-controls">
        <ProfileTypeSelect {...profileTypesProps} />
        {profileType?.aggregation === ProfileTypeAggregations.SUM && (
          <S.Badge>
            {intl.formatMessage({
              id: "conprof.profile_type.rate"
            })}
          </S.Badge>
        )}
      </S.Section>
      <S.Section className="time-controls">
        <ComparisonModeSwitch {...comparisonModeProps} />
        <TimeframeControl {...typeframeProps} />
      </S.Section>
    </S.Layout>
  );
};

export default Controls;
